export const logError = (
  err: unknown,
  customAttributes?: Record<string, string | number | null | undefined>
) => {
  console.error(err);

  if (typeof window !== 'undefined' && process.env.ENABLE_DT_LOGGING) {
    window.newrelic?.noticeError?.(err, customAttributes);
  }
};

if (typeof window !== 'undefined') {
  (window as any).logError = logError;
}
